import { TweenLite } from 'gsap/TweenLite';
import { CSSPlugin } from 'gsap/all';

/* eslint-disable */
// let this be please
const plugins = [CSSPlugin];
/* eslint-enable */

const SELECTORS = {
    BANNER: '.js-notification-banner',
    CLOSE: '.js-notification-banner-close',
};

const MODIFIER = 'notification-banner--hidden';
const STORAGE_KEY = 'notification-banner-hidden';

function initNotificationBanner() {
    const notificationBanner = document.querySelector(SELECTORS.BANNER);
    if (notificationBanner) {
        const close = notificationBanner.querySelector(SELECTORS.CLOSE);
        const { sessionStorage } = window;
        const isHidden = notificationBanner.classList.contains(MODIFIER);
        const shouldHide = sessionStorage.getItem(STORAGE_KEY);

        if (isHidden && !shouldHide) {
            notificationBanner.classList.remove(MODIFIER);
            close.setAttribute('aria-expanded', false);
            notificationBanner.setAttribute('aria-hidden', false);

            close.addEventListener('click', (e) => {
                e.preventDefault();

                sessionStorage.setItem(STORAGE_KEY, true);
                close.setAttribute('aria-expanded', true);
                notificationBanner.setAttribute('aria-hidden', true);

                TweenLite.to(notificationBanner, 0.3, {
                    height: 0,
                });
            });
        }
    }
}

export { initNotificationBanner };
